function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '..';
import useCookieStore from '../../hooks/useCookieStore';
import { COOKIE_CONSENT_CATEGORIES, COOKIE_CONSENT_STATE } from '../GoogleConsentCookieBanner';
import { LocalConsentStatus } from '../GoogleConsentCookieBanner/types';
import './style.scss';
var CookieWrapper = function CookieWrapper(_ref) {
  var children = _ref.children,
    url = _ref.url;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCookieStore = useCookieStore(COOKIE_CONSENT_CATEGORIES),
    _useCookieStore2 = _slicedToArray(_useCookieStore, 1),
    categories = _useCookieStore2[0];
  var _useCookieStore3 = useCookieStore(COOKIE_CONSENT_STATE),
    _useCookieStore4 = _slicedToArray(_useCookieStore3, 2),
    consent = _useCookieStore4[0],
    setConsent = _useCookieStore4[1];
  var consentStatus = categories && typeof categories === 'string' ? JSON.parse(categories).consent : null;
  var editCookies = function editCookies() {
    setConsent(JSON.stringify({
      status: LocalConsentStatus.STATUS_EDITING,
      version: '1.0.0'
    }));
  };

  // If Analytical and Marketing cookies are not accepted, show the CookieWrapper,
  // to prevent externally loaded content from placing cookies.
  var blockContent = !consent || !categories || (consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.analytics_storage) !== 'granted' || (consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.ad_personalization) !== 'granted' || (consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.ad_user_data) !== 'granted' || (consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.ad_storage) !== 'granted';
  if (blockContent) {
    return /*#__PURE__*/React.createElement("div", {
      className: "CookieWrapper"
    }, /*#__PURE__*/React.createElement(Icon, {
      flair: "outlined",
      name: "cookie"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "CookieWrapper__title"
    }, t('cookie.wrapper.title', 'Cookies required')), /*#__PURE__*/React.createElement("p", {
      className: "CookieWrapper__description"
    }, t('cookie.wrapper.description', 'Analytics and Marketing cookies are required to display this content.')), /*#__PURE__*/React.createElement(Button, {
      className: "CookieWrapper__edit",
      primary: false,
      onClick: function onClick() {
        return editCookies();
      }
    }, t('cookie.wrapper.button', 'Change cookiesettings')), url && /*#__PURE__*/React.createElement(Button, {
      href: url,
      className: "CookieWrapper__url",
      primary: false,
      target: "_blank",
      rel: "noreferrer"
    }, t('cookie.wrapper.url', 'Watch video in new tab')));
  }
  return children;
};
export default CookieWrapper;